import { defineStore } from "pinia"
import {
  makeDataFetchCache,
  cachedDataFetch,
} from "@/services/repowerAPIService.js"

function loadPrices(cache, path, dateRange, onSuccess, onFail) {
  cachedDataFetch(
    `/market-prices/${path}`,
    cache,
    null,
    dateRange,
    onSuccess,
    onFail,
  )
}

export default defineStore("marketPricesStore", {
  state: () => ({
    loading: false,
    dayAheadPrices: makeDataFetchCache(),
    imbalancePrices: makeDataFetchCache(),
  }),
  actions: {
    loadDayAheadPrices(dateRange, onSuccess, onFail) {
      loadPrices(
        this.dayAheadPrices,
        "day-ahead/",
        dateRange,
        onSuccess,
        onFail,
      )
    },
    loadImbalancePrices(dateRange, onSuccess, onFail) {
      loadPrices(
        this.imbalancePrices,
        "imbalance/combined/?provider=Tennet",
        dateRange,
        onSuccess,
        onFail,
      )
    },
  },
})
